import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IWarehouseStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IWarehouseStatsResponse>,
  IPathBaseParam,
  object
>("stores.users.stats");

export const stats = {
  ...getApis,
};
